/** @jsx jsx */
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { CircularProgress } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

export const StyledCircularProgress = styled(CircularProgress)<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  color: theme.colors.paletteFromBO.main,
}));

const CenteredLoader = (props: { [key: string]: unknown }): JSX.Element => (
  <div
    css={{
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      width: '100%',
      flex: 1,
    }}
  >
    <StyledCircularProgress {...props} />
  </div>
);

export default CenteredLoader;
